import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiveIndicatorBar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 4,
	height: 78,
	viewBox: "0 0 4 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0C2.20914 0 4 1.79086 4 4V74C4 76.2091 2.20914 78 0 78V0Z",
		fill: "url(#paint0_linear_8944_33298)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_8944_33298",
		x1: 1.99962,
		y1: 78,
		x2: 1.99962,
		y2: 1.17167e-9,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF2882" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FF6900"
		})]
	}) })]
});
export default SvgLiveIndicatorBar;
